import { SITE_TIME_ZONE } from '@/site.config'

const DATE_FORMAT: Intl.DateTimeFormatOptions = {
  day: 'numeric',
  month: 'long',
  year: 'numeric',
  // Pinned so the server (UTC) and the browser render the same day — a date
  // that differs between SSR HTML and hydration is a React #418 error.
  timeZone: SITE_TIME_ZONE,
}

/** Human date (e.g. "1. februar 2026") in the site's time zone. Returns '' for
 *  an unparseable input; falls back to English for an unknown locale tag. */
export function formatDate(iso: string | undefined, locale: string): string {
  if (!iso) return ''
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return ''
  try {
    return date.toLocaleDateString(locale, DATE_FORMAT)
  } catch {
    return date.toLocaleDateString('en', DATE_FORMAT)
  }
}
